(() => {
  if (window.WSWishlist) { window.WSWishlist.initialize(); return; }
  let storageHealthy = true;
  const STORAGE_KEY = 'wundersaam_wishlist_v1';
  const ASPEGREN_PARENT_ID = 'gid://shopify/Product/10279844643144';
  const ASPEGREN_PARENT_HANDLE = 'aspegren-gestrickte-spueltuecher';
  const ASPEGREN_LEGACY_VARIANTS = new Map([
    ['gid://shopify/Product/10175997182280', '54059222565192'],
    ['gestrickte-spultucher-solid-zeitloser-kuchenstil', '54059222565192'],
    ['gid://shopify/Product/10175997280584', '54059222597960'],
    ['gestrickte-spultucher-solid-weiche-strickstruktur', '54059222597960'],
    ['gid://shopify/Product/10175997116744', '54059222630728'],
    ['gestrickte-spultucher-solid-nachhaltiges-wohnen', '54059222630728'],
    ['gid://shopify/Product/10175997083976', '54059222663496'],
    ['gestrickte-spultucher-solid-moderner-kuchenstil', '54059222663496'],
    ['gid://shopify/Product/10175997247816', '54059222696264'],
    ['gestrickte-spultucher-solid-funktionale-kuchentextilien', '54059222696264'],
    ['gid://shopify/Product/10175997346120', '54059222729032'],
    ['gestrickte-spultucher-solid-skandinavisches-design', '54059222729032'],
  ]);
  const LUBECH_PARENT_ID = 'gid://shopify/Product/10283400036680';
  const LUBECH_PARENT_HANDLE = 'lubech-living-jubilaeumstopf';
  const LUBECH_LEGACY_VARIANTS = new Map([
    ['gid://shopify/Product/10176000393544', '54076349448520'],
    ['jubilaumstopf-hellgrau', '54076349448520'],
    ['gid://shopify/Product/10176000360776', '54076371861832'],
    ['jubilaumstopf-taupe', '54076371861832'],
  ]);
  const MOI_MILI_PARENT_ID = 'gid://shopify/Product/10284023316808';
  const MOI_MILI_PARENT_HANDLE = 'moi-mili-leinengirlande-circus';
  const MOI_MILI_LEGACY_VARIANTS = new Map([
    ['gid://shopify/Product/10175998656840', '54078602412360'],
    ['leinengirlande-circus-mit-halbmonden', '54078602412360'],
    ['gid://shopify/Product/10175998722376', '54078602445128'],
    ['leinen-girlande-powder-pink-circus-mit-halbmond-motiven', '54078602445128'],
  ]);
  const drawer = document.querySelector('[data-wishlist-drawer]');
  const backdrop = document.querySelector('[data-wishlist-backdrop]');
  const list = document.querySelector('[data-wishlist-list]');
  const empty = document.querySelector('[data-wishlist-empty]');
  let returnFocus = null;

  const heart = '<svg aria-hidden="true" viewBox="0 0 24 24"><path d="M12 20.5C6.6 16.7 4 13.6 4 10.1A4.1 4.1 0 0 1 12 8.5a4.1 4.1 0 0 1 8 1.6c0 3.5-2.6 6.6-8 10.4Z"></path></svg>';
  const safeText = (value, max = 500) => String(value || '').trim().slice(0, max);
  const sanitizeEntry = (entry) => {
    const type = entry?.type === 'buyable' ? 'buyable' : '';
    const id = safeText(entry?.id, 100);
    const handle = safeText(entry?.handle, 180);
    if (!type || !id || !handle) return null;
    return {
      id, handle, type,
      title: safeText(entry.title), vendor: safeText(entry.vendor, 220), price: safeText(entry.price, 80).replace(/^(ab\s+)?€\s*([\d.,]+)$/, '$1$2\u00a0€'),
      image: safeText(entry.image, 1200), url: safeText(entry.url, 700),
    };
  };
  const read = () => {
    try {
      storageHealthy = true;
      const parsed = JSON.parse(localStorage.getItem(STORAGE_KEY) || '[]');
      if (!Array.isArray(parsed)) throw new Error('invalid-wishlist');
      return Array.isArray(parsed) ? parsed.map(sanitizeEntry).filter(Boolean) : [];
    } catch { storageHealthy = false; return []; }
  };
  const write = (entries) => {
    if (!storageHealthy) return false;
    try { localStorage.setItem(STORAGE_KEY, JSON.stringify(entries.map(sanitizeEntry).filter(Boolean))); } catch { return false; }
    return true;
  };
  const entryFromNode = (node) => sanitizeEntry({
    id: node.dataset.wishlistProductId,
    handle: node.dataset.wishlistHandle,
    type: node.dataset.wishlistType,
    title: node.dataset.wishlistTitle,
    vendor: node.dataset.wishlistVendor,
    price: node.dataset.wishlistPrice,
    image: node.dataset.wishlistImage,
    url: node.dataset.wishlistUrl || node.dataset.productUrl,
  });
  const resolve = (entry) => {
    const resolved = sanitizeEntry(entry);
    if (!resolved) return null;
    const migration = [
      { parentId: ASPEGREN_PARENT_ID, parentHandle: ASPEGREN_PARENT_HANDLE, variants: ASPEGREN_LEGACY_VARIANTS },
      { parentId: LUBECH_PARENT_ID, parentHandle: LUBECH_PARENT_HANDLE, variants: LUBECH_LEGACY_VARIANTS },
      { parentId: MOI_MILI_PARENT_ID, parentHandle: MOI_MILI_PARENT_HANDLE, variants: MOI_MILI_LEGACY_VARIANTS },
    ].find((candidate) => candidate.variants.has(resolved.id) || candidate.variants.has(resolved.handle));
    if (!migration) return resolved;
    const variantId = migration.variants.get(resolved.id) || migration.variants.get(resolved.handle);
    return {
      ...resolved,
      id: `${migration.parentId}:${variantId}`,
      handle: migration.parentHandle,
      url: `/products/${migration.parentHandle}?variant=${variantId}`,
    };
  };
  const entries = () => {
    const current = read();
    let changed = false;
    const migrationParents = [ASPEGREN_PARENT_ID, LUBECH_PARENT_ID, MOI_MILI_PARENT_ID];
    const migratedParentVariants = new Set();
    const resolved = current.map((entry) => {
      const next = resolve(entry);
      if (next && (next.id !== entry.id || next.handle !== entry.handle || next.url !== entry.url)) changed = true;
      return next;
    }).filter((entry) => {
      if (!entry) return false;
      if (!migrationParents.some((parentId) => entry.id.startsWith(`${parentId}:`))) return true;
      if (migratedParentVariants.has(entry.id)) {
        changed = true;
        return false;
      }
      migratedParentVariants.add(entry.id);
      return true;
    });
    if (changed) write(resolved);
    return resolved;
  };
  const has = (id) => entries().some((entry) => entry.id === id);
  const updateControls = () => {
    const current = entries();
    document.querySelectorAll('[data-wishlist-toggle]').forEach((button) => {
      const pressed = current.some((entry) => entry.id === button.dataset.wishlistToggle);
      const title = button.dataset.wishlistTitle || 'Produkt';
      const inactiveLabel = 'Merken';
      const activeLabel = 'Gemerkt';
      button.setAttribute('aria-pressed', String(pressed));
      button.setAttribute('aria-label', `${pressed ? activeLabel : inactiveLabel}: ${title}`);
      if (button.classList.contains('wishlist-toggle--compact')) button.title = button.getAttribute('aria-label');
      const label = button.querySelector('[data-wishlist-toggle-label]');
      if (label) label.textContent = pressed ? activeLabel : inactiveLabel;
    });
    document.querySelectorAll('[data-wishlist-count]').forEach((count) => {
      count.textContent = current.length ? String(current.length) : '';
      count.dataset.count = String(current.length);
    });
  };
  const makeToggle = (entry, mode) => {
    const button = document.createElement('button');
    button.type = 'button';
    button.className = `wishlist-toggle wishlist-toggle--${mode}`;
    button.dataset.wishlistToggle = entry.id;
    button.dataset.wishlistTitle = entry.title;
    button.dataset.wishlistType = entry.type || 'product';
    const initialLabel = 'Merken';
    button.innerHTML = heart + (mode === 'pdp' ? `<span data-wishlist-toggle-label>${initialLabel}</span>` : '');
    return button;
  };
  const initializeProducts = (scope = document) => {
    const nodes = scope.matches?.('[data-wishlist-product-id]') ? [scope] : Array.from(scope.querySelectorAll?.('[data-wishlist-product-id]') || []);
    nodes.forEach((node) => {
      const entry = entryFromNode(node);
      if (!entry) return;
      if (node.matches('[data-product-card]')) {
        const slot = node.querySelector('[data-card-wishlist-slot]');
        const target = slot || node.querySelector('.product-card__media-stage');
        if (target && !node.querySelector('[data-wishlist-toggle]')) target.append(makeToggle(entry, slot ? 'compact' : 'card'));
      } else if (node.matches('[data-product-page]')) {
        const wishlistSlot = node.querySelector('[data-pdp-wishlist-slot]');
        if (wishlistSlot && !wishlistSlot.querySelector('[data-wishlist-toggle]')) wishlistSlot.append(makeToggle(entry, 'pdp'));
      }
    });
    updateControls();
  };
  const renderItem = (entry) => {
    const item = document.createElement('li'); item.className = 'wishlist-item';
    const imageLink = document.createElement('a'); imageLink.className = 'wishlist-item__image'; imageLink.href = entry.url || '#'; imageLink.setAttribute('aria-label', entry.title);
    const image = document.createElement('img'); image.src = entry.image; image.alt = ''; image.width = 164; image.height = 205; image.loading = 'lazy'; imageLink.append(image);
    const copy = document.createElement('div'); copy.className = 'wishlist-item__copy';
    const vendor = document.createElement('p'); vendor.className = 'wishlist-item__vendor'; vendor.textContent = entry.vendor;
    const title = document.createElement('a'); title.className = 'wishlist-item__title'; title.href = entry.url || '#'; title.textContent = entry.title;
    const price = document.createElement('p'); price.className = 'wishlist-item__price'; price.textContent = entry.price;
    copy.append(vendor, title, price);
    const remove = document.createElement('button'); remove.type = 'button'; remove.className = 'wishlist-item__remove'; remove.dataset.wishlistRemove = entry.id; remove.setAttribute('aria-label', `${entry.title} vom Merkzettel entfernen`); remove.textContent = '×';
    item.append(imageLink, copy, remove); return item;
  };
  const renderDrawer = () => {
    const current = entries();
    const active = document.activeElement;
    const previousButtons = [...(list?.querySelectorAll('[data-wishlist-remove]') || [])];
    const activeIndex = previousButtons.indexOf(active);
    const restore = !!list?.contains(active);
    list?.replaceChildren(...current.map(renderItem));
    if (restore && drawer && !drawer.hidden) {
      const buttons = [...list.querySelectorAll('[data-wishlist-remove]')];
      (buttons[Math.min(Math.max(activeIndex, 0), buttons.length - 1)] || drawer.querySelector('[data-wishlist-close]'))?.focus();
    }
    if (empty) empty.hidden = current.length > 0;
    updateControls();
    current.filter((entry) => entry.type === 'buyable').forEach(async (entry) => {
      try {
        const response = await fetch(`/products/${encodeURIComponent(entry.handle)}.js`, { credentials: 'same-origin' });
        if (response.status === 404 || response.status === 410) remove(entry.id);
      } catch { /* A transient network failure must not discard a saved item. */ }
    });
  };
  const reportStorageError = () => {
    let status = document.querySelector('[data-wishlist-storage-error]');
    if (!status) {
      status = document.createElement('p');
      status.dataset.wishlistStorageError = '';
      status.setAttribute('role', 'alert');
      status.style.cssText = 'position:fixed;bottom:16px;left:16px;right:16px;z-index:2000;padding:16px;background:#fff7eb;color:#512c1b;border:1px solid #845134';
      document.body.append(status);
    }
    status.textContent = window.WSTheme?.strings?.homeB?.saved_error || 'Merken gerade nicht möglich. Bitte lokalen Speicher erlauben.';
    setTimeout(() => status.remove(), 8000);
  };
  const toggle = (entry) => {
    const current = entries();
    const index = current.findIndex((item) => item.id === entry.id);
    if (index >= 0) current.splice(index, 1); else current.push(entry);
    if (!write(current)) { reportStorageError(); return false; }
    renderDrawer(); return true;
  };
  const remove = (id) => { if (!write(entries().filter((entry) => entry.id !== id))) { reportStorageError(); return false; } renderDrawer(); return true; };
  const open = (trigger) => {
    if (!drawer || !backdrop) return;
    returnFocus = trigger || document.activeElement;
    drawer.hidden = false; backdrop.hidden = false; drawer.setAttribute('aria-hidden', 'false');
    document.body.classList.add('wishlist-is-open');
    document.querySelectorAll('[data-wishlist-open]').forEach((button) => button.setAttribute('aria-expanded', 'true'));
    renderDrawer(); drawer.querySelector('[data-wishlist-close]')?.focus();
  };
  const close = () => {
    if (!drawer || !backdrop) return;
    drawer.hidden = true; backdrop.hidden = true; drawer.setAttribute('aria-hidden', 'true');
    document.body.classList.remove('wishlist-is-open');
    document.querySelectorAll('[data-wishlist-open]').forEach((button) => button.setAttribute('aria-expanded', 'false'));
    returnFocus?.focus();
  };
  document.addEventListener('click', (event) => {
    const toggleButton = event.target.closest('[data-wishlist-toggle]');
    if (toggleButton) {
      const owner = toggleButton.closest('[data-wishlist-product-id]');
      const entry = owner ? entryFromNode(owner) : null;
      if (entry) { event.preventDefault(); event.stopPropagation(); toggle(entry); }
      return;
    }
    const removeButton = event.target.closest('[data-wishlist-remove]');
    if (removeButton) { remove(removeButton.dataset.wishlistRemove); return; }
    const openButton = event.target.closest('[data-wishlist-open]');
    if (openButton) { open(openButton); return; }
    if (event.target.closest('[data-wishlist-close]') || event.target === backdrop) close();
  });
  document.addEventListener('keydown', (event) => {
    if (!drawer || drawer.hidden) return;
    if (event.key === 'Escape') { event.preventDefault(); close(); return; }
    if (event.key !== 'Tab') return;
    const focusable = Array.from(drawer.querySelectorAll('a[href], button:not([disabled])')).filter((element) => !element.hidden);
    if (!focusable.length) return;
    const first = focusable[0], last = focusable[focusable.length - 1];
    if (!drawer.contains(document.activeElement)) { event.preventDefault(); (event.shiftKey ? last : first).focus(); }
    else if (event.shiftKey && document.activeElement === first) { event.preventDefault(); last.focus(); }
    else if (!event.shiftKey && document.activeElement === last) { event.preventDefault(); first.focus(); }
  });
  document.addEventListener('wundersaam:collection-updated', (event) => initializeProducts(event.detail?.scope || document));
  document.addEventListener('shopify:section:load', (event) => initializeProducts(event.target));
  window.addEventListener('storage', (event) => { if (event.key === STORAGE_KEY) renderDrawer(); });
  window.addEventListener('pageshow', () => initializeProducts());
  initializeProducts(); renderDrawer();
  window.WSWishlist = Object.freeze({ key: STORAGE_KEY, entries, has, open, close, initialize: initializeProducts });
})();
